//Replaces special characters in a string so that it may be used as part of a 'pretty' URL.
export default (str, sep = '-') => (
  str.replace(/[^\w]+/g, sep).toLowerCase()
);
